import { render, staticRenderFns } from "./DocumentRepositoryManagerDetail.vue?vue&type=template&id=4f7c1692&scoped=true"
import script from "./DocumentRepositoryManagerDetail.vue?vue&type=script&lang=js"
export * from "./DocumentRepositoryManagerDetail.vue?vue&type=script&lang=js"
import style0 from "./DocumentRepositoryManagerDetail.vue?vue&type=style&index=0&id=4f7c1692&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7c1692",
  null
  
)

export default component.exports